<template>
  <div class="vx-card mt-4">
    <form @submit.prevent="check(barcodeNo)">
      <div class="mt-5 vx-row items-center justify-center mb-2">
        <span class="mr-5">Serino Giriniz:</span>
        <vs-input v-model="barcodeNo" class placeholder="Serino" />
        <vs-button class="ml-5 ">Ara</vs-button>
      </div>
    </form>
    <div>
      <div>
        <vs-table noDataText="Tabloda Veri Yok" :data="result">
          <template slot="thead">
            <vs-th style="width: 50px;">İşlem Tarihi</vs-th>
            <vs-th style="width: 20px;">Adet</vs-th>
            <vs-th style="width: 50px;">İşlem Türü</vs-th>
            <vs-th style="width: 50px;">Depo</vs-th>
            <vs-th style="width: 200px;">Ürün</vs-th>
            <vs-th style="width: 200px;">Müşteri</vs-th>
            <vs-th style="width: 75px;">Personel</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr id="profile-connection" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td style="width: 50px;">{{ tr.createdDate && tr.createdDate.substr(0, 10) }}</vs-td>
              <vs-td style="width: 20px;">{{ tr.quantity }}</vs-td>
              <vs-td style="width: 50px;">{{ tr.actionType }}</vs-td>
              <vs-td style="width: 50px;">{{ tr.wareHouse }}</vs-td>
              <vs-td style="width: 200px;">{{ tr.product }}</vs-td>
              <vs-td style="width: 200px;">{{ tr.customer }}</vs-td>
              <vs-td style="width: 75px;">{{ tr.personnel }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
export default {
  data() {
    return {
      barcodeNo: "",
      result: "-",
      didYouMean: false,
      hide: true,
      lastBacodeNo: "",
      timer: "",
    };
  },
  methods: {
    check: async function() {
      let a = await repository.getAll("Inventory/GetStockActionsByBarcode?serialNumber=" + this.barcodeNo);

      this.barcodeCheckRequestErrorHandler(a);
      this.result = a.list;
      this.didYouMean = a.list[0] && a.list[0].serialNumber;
      this.hide = false;
      this.lastBacodeNo = this.barcodeNo;
      this.timer = new Date();
    },
    barcodeCheckRequestErrorHandler(r) {
      if (!r || !Array.isArray(r.list)) {
        this.$vs.notify({
          title: "Serino",
          text: "Serino bulunamadı!",
          color: "danger",
        });
        return false;
      }
      if (r.hasExceptionError || r.exceptionMessage || !r.isSuccessful) {
        this.$vs.notify({
          title: "Serino",
          text: r.exceptionMessage || "Bilinmeyen bir hata oluştu!",
          color: "danger",
        });
        return false;
      }
      if (r.list.length < 1) {
        this.$vs.notify({
          title: "Serino",
          text: "Serino uyuşmazlık hatası",
          color: "danger",
        });
        return false;
      }
      return true;
    },
    showStockAction: async function() {
      let i = await repository.getAll("Inventory/GetStockActionsByBarcode?serialNumber=" + this.barcodeNo);
      this.barcodeCheckRequestErrorHandler(i);
      this.result = i.list;
      this.didYouMean = i.list[0] && i.list[0].serialNumber;
      this.hide = false;
      this.lastBacodeNo = this.barcodeNo;
      this.timer = new Date();
    },
  },
  created() {
    if (this.$route.name == "ProductBySerialCode") {
      this.barcodeNo = this.$route.params.serialCode;
      this.showStockAction();
    }
  },
};
</script>
